import React from 'react';
import PropTypes from 'prop-types';

// helpers
import classnames from 'classnames';

// styles
import styles from './styles/Title.scss';

export const Title = ({ header, title, titleUrl, trackTileClick }) => {
    if (!title) {
        return null;
    }

    const titleClasses = classnames(styles.title, {
        [styles.noHeader]: !header,
    });

    if (!titleUrl) {
        return <div className={titleClasses}>{title}</div>;
    }

    return (
        <div className={titleClasses}>
            <a
                className={styles.titleLink}
                href={titleUrl}
                target="_blank"
                rel="noopener noreferrer"
                onClick={trackTileClick}
            >
                {title}
            </a>
        </div>
    );
};

Title.propTypes = {
    header: PropTypes.string,
    title: PropTypes.string,
    titleUrl: PropTypes.string,
    trackTileClick: PropTypes.func.isRequired,
};
